define([
  'app/control/applicant_uploader',
  'app/modules/forms',
  'app/constants/steps'
], (ApplicantUploader, Forms, STEPS_CONSTANTS) => {
  const getJobSteps = function (company_id, job_id) {
    const url = `/companies/${company_id}/jobs/${job_id}/steps`;
    const stepsList = $('#applicant_upload_job_step_id');

    if (job_id) {
      $.ajax({
        type: 'GET',
        url,
        dataType: 'json',
        success(data) {
          let optionsSteps = '';

          $.each(data, (i, step) => {
            if (step.name !== STEPS_CONSTANTS.SUGGESTED) {
              optionsSteps += `<option class="not-empty" value="${step.id}">${step.name}</option>`;
            }
          });

          stepsList.find('.not-empty').remove();
          stepsList.append(optionsSteps);
          stepsList.trigger('chosen:updated');
        }
      });
    } else {
      stepsList.find('.not-empty').remove();
      stepsList.trigger('chosen:updated');
    }
  };

  const resetModal = function (uploader) {
    $('#applicant_upload_job_id').val('').trigger('chosen:updated');
    $('#applicant_upload_job_step_id').val('').trigger('chosen:updated');
    $('#applicant_upload_is_referral_tag').iCheck('uncheck');
    $('.add-applicants-form').find('.alert').remove();
    uploader.resetUploader();
  };

  const showModal = function () {
    $('.modal-add-applicants').modal('show');
  };

  const hideModal = function () {
    $('.modal-add-applicants').modal('hide');
  };

  const setJob = function (el) {
    const jobId = el.data('job-id');
    if (jobId) $('#applicant_upload_job_id').val(jobId).trigger('chosen:updated').trigger('change');
  };

  const init = function () {
    const uplResume = new ApplicantUploader($('#applicants_resume'));

    $('#applicant_upload_job_id').chosen().bind('change', function () {
      const selected = $(this).find(':selected');
      getJobSteps($(this).data('company-id'), selected.val());
    });

    $('body').on('click', '.add-applicants', (e) => {
      e.preventDefault();
      e.stopPropagation();
      resetModal(uplResume);
      setJob($('.modal-add-applicants'));
      showModal();
    });

    $('body').on('click', '.add-applicants__job-menu', function (e) {
      e.preventDefault();
      e.stopPropagation();
      resetModal(uplResume);
      setJob($(this));
      showModal();
    });

    $('body').on('submit', '.add-applicants-form', function (e) {
      e.preventDefault();
      Forms.submitWithFiles($(this), '', (data, form) => {
        if (data.success_html) form.prepend(data.success_html);
        setTimeout(() => {
          hideModal();
          resetModal(uplResume);
          document.location.reload();
        }, 3000);
      });
    });
  };

  return {
    init
  };
});
